import { AuxiliumComponent } from "../auxilium-component";

export default class List extends AuxiliumComponent {
	#showingAll = true;

	static observable = ["type", "orientation", "gap", "button-padding"];
	static observableBooleans = ["ordered", "flush", "clickable"];

	constructor() {
		super();

		this.initialShow = parseInt(this.getAttribute("initial-show")) || -1;
	}

	addItem(item, list) {
		list ??= this.querySelector(":scope>ul, :scope>ol");

		if (list) {
			list.appendChild(document.createElementWithContents("li", item));
		}
	}

	getItems() {
		return [...this.querySelectorAll(":scope>chip-listitem, :scope>*>li>chip-listitem")];
	}

	toggleVisibility() {
		if (this.initialShow > -1) {
			if (!this.#showingAll) {
				this.getItems().forEach(x => x.hide = false);
			} else {
				this.getItems().forEach((item, ix) => item.hide = ix >= this.initialShow);
			}

			this.#showingAll = !this.#showingAll;
		}
	}

	removeItem(item) {
		if (item.parentElement?.nodeName === "LI") { item.parentElement.remove(); }
		else { item.remove(); }
	}

	parsedCallback() {
		const list = document.createElement(this.ordered ? "ol" : "ul");

		this.querySelectorAll(":scope > chip-listitem").forEach(item => this.addItem(item, list));

		if (this.flush) { list.classList.add("list-flush"); }
		if (this.gap) { list.classList.add(`spaced-list--${this.gap}`); }

		this.appendChild(list);

		this.toggleVisibility();
	}
}
